import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DynamicBitArray } from './dynamic-bit-array';
export var NodeAnchorProvider = /*#__PURE__*/function () {
  function NodeAnchorProvider() {
    _classCallCheck(this, NodeAnchorProvider);
    _defineProperty(this, "cache", new WeakMap());
    _defineProperty(this, "count", BigInt(0));
    _defineProperty(this, "existingPos", new DynamicBitArray());
  }
  return _createClass(NodeAnchorProvider, [{
    key: "getOrGenerateId",
    value:
    // We use pos to generate unique ids for each node at a specific position
    // This is to ensure the same ADF will always generate the same DOM initially
    function getOrGenerateId(node, pos) {
      if (this.cache.has(node)) {
        return this.cache.get(node);
      }
      var idSuffix = '';
      if (this.existingPos.get(pos)) {
        idSuffix = "-".concat((this.count++).toString(36));
      } else {
        this.existingPos.set(pos, true);
      }
      var anchorName = "--anchor-".concat(node.type.name, "-").concat(pos).concat(idSuffix);
      this.cache.set(node, anchorName);
      return anchorName;
    }
  }, {
    key: "getIdForNode",
    value: function getIdForNode(node) {
      return this.cache.get(node) || undefined;
    }
  }]);
}();
var nodeIdProviderMap = new WeakMap();

// Get the NodeIdProvider for a specific EditorView instance.
// This allows access to the node ids anywhere.
export var getNodeIdProvider = function getNodeIdProvider(editorView) {
  if (!nodeIdProviderMap.has(editorView)) {
    var provider = new NodeAnchorProvider();
    nodeIdProviderMap.set(editorView, provider);
    return provider;
  }

  // This is based on the fact that editorView is a singleton.
  return nodeIdProviderMap.get(editorView);
};